<template>
    <div>
        <kendo-datetimepicker :ref="'datepickerdetails' + uid"
                              :value="dateValue"
                              :readonly="true"
                              v-model="dateValue"
                              :format="customFormat"
                              style="width: 100%;">
        </kendo-datetimepicker>
    </div>
</template>

<script>
    export default {
        props: {
            value: [Date, String],
            convertToLocalTime: {
                type: Boolean,
                default: true
            },
            format: {
                type: String
            },
            showTime: {
                type: [Boolean, String],
                default: true
            },
            showOnlyYear: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                uid: Math.floor((Math.random()) * 0x10000).toString(16),
                dateValue: '',
                changedFromPicker: false,
                customFormat: ''
            }
        },
        methods: {
            convertFromUtcToLocal() {
                if (this.value) {
                    let dateUtc = new Date(this.value);
                    if (dateUtc) {
                        this.dateValue = new Date(Date.UTC(dateUtc.getFullYear(),
                            dateUtc.getMonth(), dateUtc.getDate(), dateUtc.getHours(), dateUtc.getMinutes(), dateUtc.getSeconds()));
                    }
                }
            }
        },
        watch: {
            value: {
                immediate: true,
                handler(newVal, oldVal) {
                    let dt = this.$refs['datepickerdetails' + this.uid]
                    if (dt) {
                        dt.kendoWidget().trigger("change");
                    }

                    if (this.changedFromPicker) {
                        this.changedFromPicker = false;
                        return;
                    }

                    if (this.convertToLocalTime) {
                        this.convertFromUtcToLocal();
                    }
                }
            }
        },
        mounted() {
            if (!this.convertToLocalTime) {
                this.dateValue = this.value;
            }
            if (!this.format) {
                if (this.showOnlyYear) {
                    this.customFormat = 'yyyy';
                } else {
                    if (!this.showTime) {
                        this.customFormat = 'dd.MM.yyyy';
                    } else {
                        this.customFormat = 'dd.MM.yyyy HH:mm';
                    }
                }
            } else {
                this.customFormat = this.format;
            }
        }
    }
</script>

<style scoped>
    div {
        background-color: whitesmoke !important;
    }
</style>
